import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { WindowEffects, windowReducer } from './store';
import { CustomWindowModule } from 'app/core/services/custom-window-service/custom-window.module';

@NgModule({
  imports: [
    CustomWindowModule,
    StoreModule.forFeature('window', windowReducer),
    EffectsModule.forFeature([WindowEffects])
  ]
})
export class WindowModule { }
